import { Validators } from '@angular/forms';
import { ControlStringProperty } from '../../../../common';
import { mustNotBeBlankValidator } from '../../../../common/utils';
import { AddressType } from '../constants';
import { AddressExtIdsModel } from './address-external-ids.model';

export class AddressDetailsModel {
  id: number;
  extId: string;
  name: string;
  street: string;
  houseNumber: string;
  cityName: string;
  postCode: string;
  country: string;
  longitude: number;
  latitude: number;
  source: AddressType;
  fullAddress: string;
  plantGate: string;
  plantGateId: string;
  deviation: number;
  creationDate: number;

  constructor(params?: AddressDetailsModel) {
    if (params) {
      Object.assign(this, params);

      this.fullAddress = AddressDetailsModel.getFullAddress(params);
    }
  }

  static getFullAddress(address: AddressDetailsModel): string {
    const defaultKeys = ['extId', 'name', 'country', 'postCode', 'cityName', 'street', 'houseNumber'];
    return address
      ? Object.keys(address)
          .filter((key: string) => defaultKeys.includes(key))
          .sort((a: string, b: string) => defaultKeys.indexOf(a) - defaultKeys.indexOf(b))
          .map((key: string) => address[key])
          .join(' | ')
      : '';
  }
}

export class AddressDetailsForm {
  id?;
  constructor(
    detailsModel: AddressDetailsModel,
    hasUpdatePermission: boolean = true,
    public name: ControlStringProperty = [
      { value: detailsModel.name, disabled: !hasUpdatePermission },
      [Validators.maxLength(35), Validators.required, mustNotBeBlankValidator],
    ],
    public country: ControlStringProperty = [
      { value: detailsModel.country, disabled: !hasUpdatePermission },
      [Validators.required],
    ],
    public city: ControlStringProperty = [
      { value: detailsModel.cityName, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ],
    public postCode: ControlStringProperty = [
      { value: detailsModel.postCode, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ],
    public street: ControlStringProperty = [
      { value: detailsModel.street, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ],
    public houseNumber: ControlStringProperty = [
      { value: detailsModel.houseNumber, disabled: !hasUpdatePermission },
      [Validators.required, mustNotBeBlankValidator],
    ],
    public plantGateId: ControlStringProperty = [
      { value: detailsModel.plantGateId, disabled: !hasUpdatePermission },
      [],
    ],
  ) {
    if (detailsModel.id) {
      this.id = [detailsModel.id, []];
    }
  }
}

export class AddressRequestModel {
  constructor(addressDetails: AddressDetailsModel, extIds: AddressExtIdsModel) {
    if (addressDetails && extIds) {
      Object.assign(this, addressDetails, extIds);
    }
  }
}
